export default __webpack_public_path__ + "260198ed345a8a44ed9ab2395a0205b7.svg";